























































































































import { checklistPostReq } from "@/services/checklist.service";
import TranslatedItem from "@/components/TranslatedItem.vue";

import draggable from "vuedraggable";

// machinegroups-overview
export default {
  data() {
    return {
      na1: false,
      initLoaded: false,
      create_dialog: false,
      create_progress: false,
      create_error: false,
      delete_dialog: false,
      delete_item: {},
      delete_progress: false,
      export_dialog: false,
      showTransferInspect: false,
      cl_item: null,

      entry_item: {},

      //----

      create_name: "",
      update_uid: null,
      delete_uid: null,
      search: "",
      headers: [
        { text: "Format ID", value: "format_id" },
        { text: "Name", value: "name" },

      ],
    };
  },
  components: {
    TranslatedItem,
  },

  mounted() {
    this.$store.state.headerTitle = this.$t("NAVI.MESSAGE_FORMATS");

    //var db = new PouchDB('dbname');

    checklistPostReq("msgformat-overview", {})
      .then((resp) => {
        if (resp.status == "success") {
          this.$store.state.message_formats = resp.data
          this.initLoaded = true;
        }
      })
      .catch((e) => {
        this.$store.dispatch("api_error", e);
      });
  },
  computed: {
    message_formats: function () {
      return this.$store.state.message_formats;
    },
  },
  methods: {

    openEntry(ev, item) {
      this.entry_item = JSON.parse(JSON.stringify(item))
      ev.preventDefault()
      this.create_dialog = true;
    },
    deleteGroup(item) {
      this.delete_uid = item.uid;
      this.delete_dialog = true;
      this.delete_item = item;
    },

    deleteGroupAction() {
      this.delete_progress = true;
      checklistPostReq("machinegroups-remove", { uid: this.delete_uid })
        .then((resp) => {
          if (resp.status == "success") {
            this.$store.state.machines_group_list = resp.data.list;
            this.delete_dialog = false;
            this.delete_progress = false;
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    deleteItem() {
      console.log("deleteItem", this.entry_item);
      checklistPostReq("msgformat-remove", {
          uid: this.entry_item.uid
        })
          .then((resp) => {
            if (resp.status == "success") {
              this.create_progress = false;
              this.$store.state.message_formats = resp.data.entries;
              this.create_dialog = false;
            }
          })
          .catch((e) => {
            this.$store.dispatch("api_error", e);
          });
    },
    saveItem() {
      this.create_error = false

      if (this.entry_item.name && this.entry_item.format_str.length > 1) {
        this.create_progress = true;

        checklistPostReq("msgformat-update", {
          entry_item: this.entry_item
        })
          .then((resp) => {
            if (resp.status == "success") {
              this.create_progress = false;
              this.$store.state.message_formats = resp.data.entries;
              this.create_dialog = false;
            }
          })
          .catch((e) => {
            this.$store.dispatch("api_error", e);
          });

      }
      else {
        this.create_error = true
      }

    },
  },
};
